import React from 'react';
import { Spinner } from 'reactstrap';
//Assets
import "../../assets/css/loading.css";
export default function Loading() {
    return (
        <div className="carregando">
            <div className="box">
                <Spinner style={{ color: "var(--primaryColor)" }}></Spinner>
            </div>
        </div>
    )
}